import { createContext } from 'react';
import type { LiveCallBooking } from '../types/liveCall';

/**
 * The thread's lessons, read once for the pair (subscribePairBookings), so
 * each lesson event card reads its lesson from here rather than holding a
 * listener of its own (audit 2 Nov, B14). `ready` once both of the pair's
 * queries have answered: a lesson missing then is not the pair's, and the
 * card reads it alone. `latest`: each lesson's newest event card, the one
 * that carries its action (audit 2 Nov, T3). Null outside a thread.
 */
export const PairBookingsContext = createContext<{
  bookings: LiveCallBooking[]; ready: boolean; latest: Record<string, string>;
} | null>(null);
